// extracted by mini-css-extract-plugin
export var productImage = "_xl-0";